'use strict';

import { sharedStorage } from '../utils/sharedStorage';
import { tabAttention } from '../coordinator/tabAttention';
import { tabPresence } from '../coordinator/tabPresence';
import { tabReconcile } from '../coordinator/tabReconcile';

/**
 * Global multi-cart bus / DOM registry (SFRA-style event register).
 * Included from main.js only under tab isolation.
 */
export const coordinator = {
  /**
   * Subscribe presence probe topics. Idempotent.
   */
  registerTabPresence() {
    if (tabPresence.isInitialized()) {
      return;
    }

    tabPresence.setInitialized();

    sharedStorage.tabChannel.subscribe('presence', payload => {
      tabPresence.onPresence(payload);
    });
    sharedStorage.tabChannel.subscribe('alive', payload => {
      tabPresence.onAlive(payload);
    });
  },

  /**
   * Subscribe attention topics and apply persisted identify titles. Idempotent.
   */
  registerTabAttention() {
    if (tabAttention.isInitialized()) {
      return;
    }

    tabAttention.setInitialized();

    sharedStorage.tabChannel.subscribe('identify', payload => {
      tabAttention.onIdentify(payload);
    });
    sharedStorage.tabChannel.subscribe('activate', payload => {
      tabAttention.onActivate(payload);
    });
    sharedStorage.tabChannel.subscribe('activate-ack', payload => {
      tabAttention.onActivateAck(payload);
    });
    sharedStorage.tabChannel.subscribe('blink', payload => {
      tabAttention.onBlink(payload);
    });
    sharedStorage.tabChannel.subscribe('blink-ack', payload => {
      tabAttention.onBlinkAck(payload);
    });

    if (tabAttention.isIdentifyEnabled()) {
      tabAttention.applyIdentify(true);
    }
  },

  /**
   * Idle + visibility triggers for Tab-Reconcile. Idempotent.
   */
  registerTabReconcile() {
    if (tabReconcile.isInitialized()) {
      return;
    }

    tabReconcile.setInitialized();

    const run = () => tabReconcile.scheduleReconcile();

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(() => run(), { timeout: 5000 });
    } else {
      window.setTimeout(run, 2000);
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        run();
      }
    });
  }
};
